<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import languageresources from "../languageresources/addedit.vue";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      languages: {},
    };
  },
  components: {
    Loader,
    languageresources,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsGet({
        Service: "languages",
        Page: Page,
      }).then((res) => {
        this.languages = res.Data;
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="languageresources"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('languageresources.AddEdit.FormTitleEdit')
          : $t('languageresources.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
      ><b-tabs content-class="p-3 text-muted">
        <template v-for="(Data, index) in languages">
          <b-tab :key="index" v-if="AddEdit == 'Edit'">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">
                <country-flag :country="Data.Flag" size="small" />
                {{ Data.Title }}</span
              >
            </template>

            <languageresources :DataId="Id.Id" :LanId="Data.Id" />
          </b-tab>
        </template>
      </b-tabs>
    </b-modal>
  </Loader>
</template>
